(function () {
	'use strict';
	MxGridSelectCtrl.$inject = ['uiGridEditConstants', 'uiGridConstants', '$scope', '$element', '$timeout'];

	function MxGridSelectCtrl(uiGridEditConstants, uiGridConstants, $scope, $element, $timeout) {
		var vm = this;
		// var dictionary = {};
		vm.$onInit = function () {
			var colDef = vm.col.colDef;

			if (!Array.isArray(colDef.item.Enumeration)) {
				colDef.item.getEnumValues();
			}

			vm.model = vm.row.entity.getEntityValue(colDef.field);

			vm.dataItems = colDef.item?.Enumeration?.filter((item) => item.hidden !== true);

			function save() {
				vm.row.entity.setEntityValue(colDef.field, vm.model, (colDef.item.EnumerationAsObject[vm.model] || {}).title);
				$scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
			}

			vm.onBlur = function () {
				$timeout(function () {
					save();
				}, 100);
			};

			$scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
				$timeout(function () {
					$element.find('select').focus();
				});
			});

			$element.on('blur', function () {
				save();
			});

			$element.on('keydown', function (evt) {
				switch (evt.keyCode) {
					case uiGridConstants.keymap.ESC:
						evt.stopPropagation();
						$scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
						break;
					//case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
					case uiGridConstants.keymap.TAB:
						evt.stopPropagation();
						evt.preventDefault();
						save();
						break;
				}

				return true;
			});

			$scope.$on('$destroy', function unbindEvents() {
				// unbind jquery events to prevent memory leaks
				$element.off();
			});
		};

		return vm;
	}

	/**
	 * @ngdoc directive
	 * @name mx.components:mxGridSelect
	 * @module mx.components
	 * @restrict 'E'
	 * @description
	 * The mx-grid-select control is used in mx-grid for inline editing
	 *
	 * @usage <mx-grid-select data-col="col" data-row="row"></mx-grid-select>
	 */
	angular.module('mx.components').directive('mxGridSelect', [
		function mxGridSelectDirective() {
			return {
				scope: {},
				restrict: 'E',
				bindToController: {
					col: '<',
					row: '<',
				},
				controller: MxGridSelectCtrl,
				controllerAs: 'vm',
				template: [
					function () {
						return `<mx-select
									ng-class="'colt' + vm.col.uid"
									data-items="vm.dataItems"
									allow-empty="{{::!vm.col.colDef.item.Required}}"
									data-on-blur="vm.onBlur"
									ng-model="vm.model"
									data-item-title-field="title"
									data-item-id-field="value"
								></mx-select>`;
					},
				],
			};
		},
	]);
})();
